import {KeyLabel} from './key-label.model';
export enum PublisherStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  ARCHIVED = 'ARCHIVED',
}

export const PublisherStatusLabels = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  ARCHIVED: 'Archived',
};

export const PublisherStatusKL = () => {
  return Object.keys(PublisherStatusLabels).map(key => new KeyLabel(key, PublisherStatusLabels[key]));
};
